// @flow

import { MDXProvider } from '@mdx-js/react'
import { MDXRenderer } from 'gatsby-plugin-mdx'
import * as React from 'react'
import type { Mdx } from 'types'

import { List, text } from '@toggl/ui'

const components = {
  h1: text.H1,
  h2: text.H2,
  h3: text.H3,
  h4: text.H4,
  h5: text.H5,
  strong: text.Strong,
  ul: List.Wrapper,
  li: List.Item,
}

export default function MDX({
  p,
  italic,
  children,
}: {
  p?: React.ComponentType<any>,
  italic?: React.ComponentType<any>,
  children: Mdx,
}) {
  if (typeof children !== 'object' || children?.body == null) {
    throw new Error(
      'Unexpectedly received something that is not compiled MDX. Check the schema or page data for changes.'
    )
  }

  return (
    <MDXProvider
      components={{
        ...components,
        p: p ?? text.P1,
        italic: italic ?? text.P1,
      }}
    >
      <MDXRenderer>{children.body}</MDXRenderer>
    </MDXProvider>
  )
}
